import React from 'react';
import { CheckCircle, Package } from 'lucide-react';

const FeaturesApplications = ({ product }) => (
  <section className="py-8 md:py-12 bg-white relative overflow-hidden">
    <div className="absolute inset-0 opacity-30">
      <div className="absolute top-0 left-0 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl" />
    </div>

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-8 md:gap-12">
        {/* Features */}
        <div className="group relative">
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
          <div className="relative bg-white/90 backdrop-blur-xl border border-gray-200 rounded-2xl p-6 sm:p-8 hover:border-cyan-300 transition-all duration-500 hover:shadow-2xl">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center mr-3 shadow-lg">
                <CheckCircle className="h-6 w-6 text-white" />
              </div>
              Key Features
            </h2>
            <ul className="space-y-4">
              {product.features.map((feature) => (
                <li key={feature} className="flex items-start space-x-3">
                  <CheckCircle className="h-5 w-5 text-cyan-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Applications */}
        <div className="group relative">
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
          <div className="relative bg-white/90 backdrop-blur-xl border border-gray-200 rounded-2xl p-6 sm:p-8 hover:border-cyan-300 transition-all duration-500 hover:shadow-2xl">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center mr-3 shadow-lg">
                <Package className="h-6 w-6 text-white" />
              </div>
              Applications
            </h2>
            <ul className="space-y-4">
              {product.applications.map((application) => (
                <li key={application} className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-cyan-600 rounded-full flex-shrink-0 mt-2" />
                  <span className="text-gray-600">{application}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default FeaturesApplications;
